import BaseBasket from '../base/basket';

export default class Basket extends BaseBasket {
}